exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label{font-weight:700;display:block;padding:.5rem}select{padding-left:.5rem;width:15rem}#column{width:30em;float:left;padding-left:40rem}#column,#selection2-group,#selection3-group{text-align:left}#spacer{padding-top:1.6em}#wrapper{background-color:#ccf;margin:22px}#woHeader{margin:0 auto;border:.5;width:100%;padding-left:.5rem;font-weight:700}#woHeader,#woHeader div{background-color:#ccf;display:inline-block}#woHeader div{padding:.1rem}.Button{font-family:Verdana,Tahoma,Arial;background-color:#ccf}div{overflow:hidden}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/sortTaskList/sortTaskList.component.scss
// module id = ./src/app/sortTaskList/sortTaskList.component.scss
// module chunks = app